import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { InputLabel } from "@mui/material";
import { Dayjs } from "dayjs";
import { ErrorMessage } from "formik";
import dayjs from "dayjs";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import "./date-picker.scss";

interface DatePickerComponentProps {
  fieldName: string;
  label?: string;
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  optional?: boolean;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  disabled?: boolean;
  error?: boolean;
  isLabel?: boolean;
  useFormikError?: boolean;
  hasBorder?: boolean;
}

const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
  fieldName,
  label,
  value,
  onChange,
  optional = false,
  minDate,
  disabled,
  maxDate,
  error,
  isLabel = true,
  useFormikError = true,
  hasBorder = false,
}) => {
  const minSelectableDate = dayjs("1999-01-01");

  return (
    <div className="custom-datepicker-wrapper">
      {isLabel && (
        <InputLabel
          htmlFor={fieldName}
          required={!optional}
          className="custom-datepicker-label"
        >
          {label}
        </InputLabel>
      )}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          value={value}
          onChange={onChange}
          minDate={minDate || minSelectableDate}
          disabled={disabled}
          maxDate={maxDate}
          format="MM/DD/YYYY"
          slotProps={{
            textField: {
              name: fieldName,
              fullWidth: true,
              className: `custom-datepicker ${value ? "has-value" : ""}`,
              label: "",
              disabled,
              error: error,
              inputProps: {
                readOnly: false,
                placeholder: `Select ${label}`,
              },
              variant: "outlined",
            } as any,
          }}
          sx={{
            ...(hasBorder && {
              "& .MuiOutlinedInput-root": {
                borderTop: "2px solid #e30000",
              },
            }),
          }}
        />
      </LocalizationProvider>
      {useFormikError && fieldName && (
        <ErrorMessage
          name={fieldName || ""}
          component="div"
          className="error-message"
        />
      )}
    </div>
  );
};

export default DatePickerComponent;
